export default __webpack_public_path__ + "static/media/Goremonger's Bracers.54da81dd.jpg";